var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 72,
    viewBox: "0 0 76 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_7",
    "data-name": "Artboard \\u2013 7",
    clipPath: "url(#clip-Artboard_7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(-304 -145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(241 -169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 89)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(76 236)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-94.267 -2.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M431.31,170.378a1.436,1.436,0,0,1,0,2.03l-3.541,3.541a.5.5,0,0,0-.048.072,2.38,2.38,0,0,0-.515.861l-.82,3.288a.5.5,0,1,0,.971.243l.809-3.251a1.319,1.319,0,0,1,1.556-.855,1.3,1.3,0,0,1,.8.6,1.318,1.318,0,0,1,.142,1.013l-.518,2.6a5.28,5.28,0,0,1-1.454,2.717l-2.738,2.738a.5.5,0,1,0,.707.707l2.738-2.738a6.263,6.263,0,0,0,1.727-3.229l.513-2.58a2.308,2.308,0,0,0-1.679-2.8l-.107-.024h-.034l2.194-2.194a2.44,2.44,0,0,0,0-3.445,2.5,2.5,0,0,0-3.445,0l-4.72,4.719a6.328,6.328,0,0,0-1.809,3.766l-.459,4.135a.5.5,0,0,0,.442.551h.056a.5.5,0,0,0,.5-.445l.459-4.135a5.33,5.33,0,0,1,1.522-3.168l4.72-4.718a1.47,1.47,0,0,1,2.031,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M445.243,186.341l-2.194,2.2V188.5a.894.894,0,0,0-.023-.1,2.3,2.3,0,0,0-2.775-1.683l-2.6.517a6.276,6.276,0,0,0-3.228,1.728l-2.739,2.738a.5.5,0,0,0,.354.853.494.494,0,0,0,.353-.146l2.739-2.738a5.287,5.287,0,0,1,2.716-1.454l2.627-.523a1.319,1.319,0,0,1,1.6,1.011,1.3,1.3,0,0,1-.831,1.486l-3.288.819a.5.5,0,1,0,.242.97l3.325-.829a2.268,2.268,0,0,0,.857-.527.437.437,0,0,0,.039-.026l3.541-3.541a1.47,1.47,0,0,1,2.031,0,1.438,1.438,0,0,1,0,2.031l-4.72,4.719a5.333,5.333,0,0,1-3.167,1.524l-4.135.459a.5.5,0,0,0,.053,1,.515.515,0,0,0,.056,0l4.137-.459a6.331,6.331,0,0,0,3.763-1.811l4.72-4.719a2.44,2.44,0,0,0,0-3.445,2.5,2.5,0,0,0-3.453-.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M446.5,174.9a4.423,4.423,0,0,0-2.4.714,5.423,5.423,0,1,0-1.74,5.351,4.451,4.451,0,1,0,4.14-6.065Zm-5.745,3.926a1.552,1.552,0,0,1-1.371.972v.3a.506.506,0,0,1-1.012,0v-.284h-.681a.506.506,0,1,1,0-1.012H439.3a.555.555,0,0,0,.207-1.071l-1.633-.654a1.562,1.562,0,0,1,.5-3.012v-.294a.506.506,0,0,1,1.012,0v.286h.681a.506.506,0,1,1,0,1.011h-1.609a.556.556,0,0,0-.206,1.071l1.631.653a1.567,1.567,0,0,1,.874,2.037Zm7.331,2.146a1.276,1.276,0,0,1-1.127.8v.244a.416.416,0,0,1-.831,0v-.234h-.56a.415.415,0,1,1,0-.831h1.322a.457.457,0,0,0,.169-.881l-1.342-.537a1.284,1.284,0,0,1,.411-2.477v-.242a.415.415,0,1,1,.831,0v.235h.56a.416.416,0,1,1,0,.832H446.2a.457.457,0,0,0-.17.88l1.341.537a1.287,1.287,0,0,1,.718,1.674Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M431.849,189.389v-2.6a.5.5,0,0,0-.5-.5h-2.6a.5.5,0,0,0,0,1h1.393l-5.126,5.126a.5.5,0,1,0,.707.707L430.849,188v1.392a.5.5,0,1,0,1,0Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpentIcon);
export default __webpack_public_path__ + "static/media/spent_icon.1ddb4751d4235703dca2456d775ef056.svg";
export { ForwardRef as ReactComponent };